/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for RIDP.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_PRIMARY_RIDP = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `RIDP/FETCH_PRIMARY_RIDP`
);

const POST_SECONDARY_RIDP = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `RIDP/POST_SECONDARY_RIDP`
);

const FETCH_FARS_RESPONSE = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `RIDP/FETCH_FARS_RESPONSE`
);

const POST_COMPLETE_FA_RS = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `RIDP/POST_COMPLETE_FA_RS`
);

const POST_RBA_RIDP = ReduxUtils.generatePostActionTypes('ua-library', `RIDP/POST_RBA_RIDP`);

const POST_GET_RECORD_RESPONSE = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `RIDP/POST_GET_RECORD_RESPONSE`
);

export {
  FETCH_PRIMARY_RIDP,
  POST_SECONDARY_RIDP,
  FETCH_FARS_RESPONSE,
  POST_COMPLETE_FA_RS,
  POST_RBA_RIDP,
  POST_GET_RECORD_RESPONSE,
};
